import { generateNgrxServiceClient } from '@essent/ngrx-service-wrapper';
import { meteringClient } from '@integration/api-client/metering';

export const { actions: MeteringApiActions, effects: MeteringApiEffects } =
  generateNgrxServiceClient('Metering', meteringClient);
